
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Delivery from '@/extend/classes/Delivery';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeDelivery' })

export default class storeDelivery extends VuexModule {
  // States
  private reccords: Delivery[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get deliveryLoading (): boolean {
    return this.dataLoading;
  }
  private get deliveryRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get deliveryLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewDelivery() {
    return (): Delivery => { 
      return this.getDelivery(0, true);
    }
  }

  
  public get getDelivery () {
    return (id: number, canCreate = false): Delivery => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Delivery can't be 0")
        return new Delivery();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Delivery();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Delivery.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromDelivery(data.reccords[0] as Delivery);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listDelivery (): Delivery[] {
    return this.reccords;
  }

  public get listConfigDelivery (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mDeliveryRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mDeliveryClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mDeliveryLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mDeliveryLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Delivery.fromJson(reccord as Delivery));
    })
    Delivery.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mDeliveryConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mDeliveryCreated (obj: Delivery): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDelivery(obj)) {
          api.fromDelivery(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareDelivery(obj)) {
            api.fromDelivery(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mDeliveryUpdated (obj: Delivery): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDelivery(obj)) {
          api.fromDelivery(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mDeliveryDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerDelivery (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.deliveryRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerDelivery(this.deliveryCreated, this.deliveryUpdated, this.deliveryDeleted);
          this.mDeliveryRegistered();
        } else {
          setTimeout(() => resolve(this.registerDelivery(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.deliveryLoading && !this.deliveryLoaded) {
          this.mDeliveryLoading(true);
          return Delivery.list(filter)
            .then((data: ListData) => {
              this.mDeliveryLoaded(data);
              this.mDeliveryLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredDelivery (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.deliveryLoading) {
        this.mDeliveryLoading(true);
        return Delivery.list(filter)
          .then((data: ListData) => {
            this.mDeliveryLoaded(data);
            this.mDeliveryLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createDelivery (obj: Delivery): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      return Delivery.fromJson(obj).createForStoreDelivery()
        .then((reccords) => {
          this.mDeliveryCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateDelivery (obj: Delivery): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      return Delivery.fromJson(obj).updateForStoreDelivery()
        .then((reccords) => {
          this.mDeliveryUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  private deliveryCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDeliveryConfigUpdated(config)
    const obj = objConfig.obj as Delivery;
    this.mDeliveryCreated(Delivery.fromJson(obj));
  }

  @Action
  private deliveryUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDeliveryConfigUpdated(config)
    const obj = objConfig.obj as Delivery;
    this.mDeliveryUpdated(Delivery.fromJson(obj));
  }

  @Action
  private deliveryDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Delivery;
    this.mDeliveryDeleted(obj.id);
  }
}
